var render, staticRenderFns
import script from "./BpDirectional.vue?vue&type=script&lang=js&"
export * from "./BpDirectional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49043a06')) {
      api.createRecord('49043a06', component.options)
    } else {
      api.reload('49043a06', component.options)
    }
    
  }
}
component.options.__file = "resources/styles/utilities/directional/BpDirectional.vue"
export default component.exports